import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"d-sm-flex align-items-center justify-content-between\"><h5 class=\"card-title fw-bold mb-0\">Task Overview</h5><div class=\"card-select mt-10 mt-sm-0 d-inline-block d-sm-flex align-items-center ps-10 pe-10 pt-5 pb-5\"><span class=\"fw-medium text-muted me-8\">Show</span><select class=\"form-select shadow-none text-black border-0 ps-0 pt-0 pb-0 pe-20 fs-14 fw-medium\"><option value=\"1\" class=\"fw-medium\" selected>All</option><option value=\"2\" class=\"fw-medium\">Sat</option><option value=\"3\" class=\"fw-medium\">Sun</option><option value=\"4\" class=\"fw-medium\">Mon</option><option value=\"5\" class=\"fw-medium\">Tue</option><option value=\"6\" class=\"fw-medium\">Wed</option><option value=\"7\" class=\"fw-medium\">Thu</option><option value=\"8\" class=\"fw-medium\">Fri</option></select></div></div>", 1)
const _hoisted_4 = {
  id: "taskOverviewChart",
  class: "chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_apexchart, {
          type: "bar",
          height: "370",
          options: _ctx.taskOverviewChart,
          series: _ctx.task
        }, null, 8, ["options", "series"])
      ])
    ])
  ]))
}